import { useLogMarketAnalyticsEvent } from './useLogMarketAnalyticsEvent';
import { useRetainedEffect } from 'shared/src/hooks/retainedState';

export const useLogViewMarket = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();
  // const [isLogged, setIsLogged] = useState(false);

  useRetainedEffect(
    'market-home-view-market',
    () => {
      logMarketAnalytics({
        name: 'VIEW_MARKET',
        analytics: {
          RESTORE: 0,
          REALTIME_RANKING_COUNT: 0,
          LANDING_FROM: null,
        },
      });
    },
    [logMarketAnalytics],
  );
};
